import { language as lan_simpleCustomizePreview } from "./simple-customize-preview";

let language = {
    ...lan_simpleCustomizePreview,

    STORE_ORDER_PLATFORM_STATUS: "Status:",
    
    STORE_ORDER_TOTAL: "Total:",

    // shipping-info
    STORE_ORDER_SHIPPING_INFO_STORE_NAME: "Store name:",
    STORE_ORDER_SHIPPING_INFO_BILLING_ADDRESS: "Billing address:",
    STORE_ORDER_SHIPPING_INFO_SHIPPING_ADDRESS: "Shipping address:",
    STORE_ORDER_SHIPPING_INFO_DELIVERY_TYPE: "Delivery type:",
    STORE_ORDER_SHIPPING_INFO_PAYMENT_TYPE: "Payment type:",
    STORE_ORDER_SHIPPING_INFO_TRACKING_NUMBER: "Tracking no:",
    STORE_ORDER_SHIPPING_INFO_TRACKING_METHOD: "Tracking method:",

    // item
    STORE_ORDER_ITEM_PAYMENT_SUBTOTAL: "Payment subtotal:",
    STORE_ORDER_ITEM_SUBWEIGHT: "Subweight:",
    STORE_ORDER_ITEM_PAYMENT_STATUS_LABEL: "Payment status:",
    STORE_ORDER_ITEM_PAYMENT_STATUS_UNSUBMITTED: "unsubmitted",
    STORE_ORDER_ITEM_PAYMENT_STATUS_SUBMITTED: "submitted",
    STORE_ORDER_ITEM_PRICE: "Price:",
    STORE_ORDER_ITEM_WEIGHT: "Weight:",
    STORE_ORDER_ITEM_PREVIEW_ACTION: "Preview",
    STORE_ORDER_ITEM_SITE_ORDER_NUMBER: "OrderNo:",

    // checkout-info
    STORE_ORDER_TOTAL_WEIGHT: "Total weight:",
    STORE_ORDER_RECEIVE_SUBTOTAL: "Receive subtotal:",
    STORE_ORDER_RECEIVE_TAX: "Receive tax:",
    STORE_ORDER_RECEIVE_SHIPPING_FEE: "Receive shipping fee:",
    STORE_ORDER_RECEIVE_TOTAL: "Receive total:",

    // btn
    STORE_ORDER_BTN_BACK: "BACK",
    STORE_ORDER_BTN_SUBMIT: "SUBMIT",
    STORE_ORDER_BTN_COMBINE_ORDER: "COMBINE ORDER",
    STORE_ORDER_BTN_DELETE: "DELETE",
};

export { language }